<template>
  <p class="text-xs font-semibold leading-snug">
    <slot>
      <i class="fas fa-crown text-yellow-500"></i>
      {{ $t('state.subscribe_to_use') }}
    </slot>
  </p>
</template>
